export default {"src":"/_next/static/media/info.83d9523f.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};